module.exports = __webpack_public_path__ + "img/2.90a7e983.png";